import { Component, Inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { AddMenuProductFromComponent } from '../../../../elements/menu-products/add-menu-product-from/add-menu-product-from.component';


@Component({
  selector: 'app-product-item-modal',
  standalone: true,
  imports: [CommonModule,
    MatDialogContent,
    AddMenuProductFromComponent]
  ,
  templateUrl: './product-item-modal.component.html',
  styleUrl: './product-item-modal.component.css'
})
export class ProductItemModalComponent implements OnInit {
  productInfo: any = undefined
  constructor(public dialogRef: MatDialogRef<ProductItemModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
      /*private sharedOrderService: SharedOrderService*/) {
  }
  ngOnInit(): void {
    // Support both shapes: data = { product } or data = product
    this.productInfo = (this.data && this.data.product) ? this.data.product : (this.data ?? {});
    console.log('ProductItemModal - productInfo:', this.productInfo);
    console.log('ProductItemModal - options:', this.productInfo?.options);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
